// extracted by mini-css-extract-plugin
export default {"container":"Table_container__6PDdg","description":"Table_description__g2jEV","wrapper":"Table_wrapper__-KaBm","table":"Table_table__0tLrq"};